export const SESSION_STORAGE_NAME = 'garriState6-' + window.garriConfig.env

export const DragDropItemTypes = {
    LIST_PRODUCT: 'list_product'
}


